import React from "react";

const PolatliTasima: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center bg-white text-gray-700 p-10">
            <h1 className="text-4xl font-bold text-[#092049] mb-6 text-center">
                Polatlı Personel Taşımacılık Hizmetlerimiz
            </h1>
            <p className="text-lg leading-relaxed text-gray-600 mb-8 text-center max-w-2xl">
                Polatlı’da personel taşımacılığı konusundaki uzmanlığımızla, işletmelerin personelini güvenli ve sorunsuz bir şekilde taşıyoruz. Polatlı’nın trafik koşullarına ve şehrin dinamik yapısına hakim olan deneyimli şoförlerimiz, personelinizin işe zamanında ve güvenle ulaşmasını sağlar.
            </p>
            <a
                href="/polatli-personel-tasimacilik"
                className="bg-[#092049] text-white px-6 py-3 rounded-lg shadow-lg hover:bg-cyan-600 transition duration-300"
            >
                Daha Fazlası İçin
            </a>
        </div>
    );
};
//[#064080] hover

export default PolatliTasima;
